import { create } from 'zustand'

type SendNominationFormStore = {
  isFormDirty: boolean
  setIsFormDirty: (isDirty: boolean) => void
}

export const useSendNominationFormStore = create<SendNominationFormStore>(set => ({
  isFormDirty: false,
  setIsFormDirty: isDirty => set({ isFormDirty: isDirty }),
}))
